import { AlgoliaIndexResultPlugin } from './AlgoliaPlugin.js';
import { ProductResultTaxonomy } from '../taxonomy/Taxonomies.js';
import { QUERY_CATEGORIZATION_EXPERIMENT_VARIATION } from '../../util/abTestConstants.js';
import { getIndexNameDiscovery } from '../../util/algolia.js';

var getFlyoutSearchParametersBuilderDiscovery = function getFlyoutSearchParametersBuilderDiscovery() {
  return function () {
    var defaultSearchParameters = {
      clickAnalytics: true,
      attributesToRetrieve: ['platformUrl', 'name', 'defaultImageUrl', 'inStock'],
      attributesToHighlight: ['name'],
      ruleContexts: ['defaultRuleContext'],
      getRankingInfo: true
    };
    return defaultSearchParameters;
  };
};
var FlyoutDiscoveryProductResultsPlugin = function FlyoutDiscoveryProductResultsPlugin(locale, hitsPerPage, queryCategorizationExperiment) {
  var taxonomyId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ProductResultTaxonomy.id;
  var indexName = getIndexNameDiscovery('Vistaprint', 'prod', locale);
  if (queryCategorizationExperiment && queryCategorizationExperiment.Variation === QUERY_CATEGORIZATION_EXPERIMENT_VARIATION) {
    indexName = "".concat(indexName, "_queryCategorization");
  }
  return AlgoliaIndexResultPlugin(indexName, indexName, taxonomyId, getFlyoutSearchParametersBuilderDiscovery(), hitsPerPage, 'products', true, 'prod');
};

export { FlyoutDiscoveryProductResultsPlugin, getFlyoutSearchParametersBuilderDiscovery };
//# sourceMappingURL=FlyoutDiscoveryResultPlugins.js.map
